module.exports = __webpack_public_path__ + "img/circle_X_red.2184de1e.svg";